<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Controle Cobranças GarantePay</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item">Controle Cobranças GarantePay</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                        <v-form>
                                            <v-container>
                                                <div class="row gp-query-filters">
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <v-autocomplete v-model="GarantidoraSelected" :items="ListGarantidorasGeral"
                                                                item-title="garNomeEmpresa" item-value="garId" density="compact" variant="outlined"
                                                                placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhuma garantidora encontrada" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Forma Pagamento</label>
                                                            <select v-model="PagamentoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListPagamentosGeral"
                                                                    :key="optionTipo.cfpId" :value="optionTipo.cfpId">{{
                                                                        optionTipo.cfpNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Ano Referência</label>
                                                            <select v-model="AnoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListAnoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Mês Cobrança</label>
                                                            <select v-model="MesSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListMesGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Situação</label>
                                                            <select v-model="SituacaSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSituacaoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12 gp-query-actions">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-info"
                                                                style="color:#ffffff;" @click="Filtar()">
                                                                <i class="fas fa-search"></i> Pesquisar
                                                            </button>
                                                            <a href="#" @click="Cancel()"
                                                                class="btn btn-outline-secondary"><i class="fas fa-eraser"></i> Limpar</a>
                                                        </div>
                                                        <button type="button" class="btn btn-info" v-show="false"
                                                            style="color:#ffffff;" @click="EmissaoNF2()">
                                                            Emitir Lista
                                                        </button>
                                                         <button type="button" class="btn btn-info" v-show="false"
                                                            style="color:#ffffff;" @click="CancelarNF2()">
                                                            Cancelar Lista
                                                        </button>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Resultado</h4>
                                </div>
                                <div style="float: right;" v-if="TotalFiltro != 0">
                                    <strong>Valor Total Filtrado: {{ TotalFiltro }}</strong>
                                </div>
                            </div>
                            <div class="card-body" v-if="ListCobrancas != '' && ListGarantidorasGeral != null">
                                <v-row>
                                    <v-col cols="12" md="3" style="text-align: right;margin-bottom: 5px;">
                                        <input v-model="NewData" type="date" class="form-control"
                                            placeholder="Data Pagamento" />
                                    </v-col>
                                    <v-col cols="12" md="2"
                                        style="text-align: right;padding-right: 15px;padding-top: 20px;">
                                        <button @click="AtualizarPagamentoMassa()" class="btn-sm btn-info">Atualizar
                                            Selecionados</button>
                                    </v-col>

                                </v-row>

                                <adm-data-table :headers="gridHeaders" :export-headers="headers" :items="ListCobrancas" v-model="itemsSelected"
                                    :show-filters="false"
                                    :export-metadata="cabecalhoExportacao"
                                    :export-formatters="formatadoresExportacao"
                                    :export-number-formats="formatosNumericosExportacao"
                                    :filter-options="{ garId: ListGarantidorasGeral.map(item => ({ title: item.garNomeEmpresa, value: item.garId })) }"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina" file-name="cobrancas-garantepay">
                                    <template #item-resumoCobranca="item">
                                        <div class="gp-charge-summary">
                                            <strong>{{ item.garantidora || '—' }}</strong>
                                            <small v-if="item.documento">{{ item.documento }}</small>
                                            <span><b>Plano:</b> {{ item.plano || '—' }}</span>
                                            <span><b>Produto:</b> {{ item.pbgDescricaoServico || '—' }}</span>
                                        </div>
                                    </template>
                                    <template #item-pbgValorGarantepay="item">
                                        <span>{{ formatarValor(item.pbgValorGarantepay) }}</span>
                                    </template>
                                    <template #item-pbgValorBase="item">
                                        <span>{{ formatarValor(item.pbgValorBase) }}</span>
                                    </template>
                                    <template #item-pbgDataVencimento="item">
                                        <span>{{ item.pbgDataVencimento != null ? formattedDate(item.pbgDataVencimento)
                                            :
                                            null }}</span>
                                    </template>
                                    <template #item-pbgDataPagamento="item">
                                        <span>{{ item.pbgDataPagamento != null ? formattedDate(item.pbgDataPagamento) :
                                            null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                        <v-btn icon @click="ConfirmaPgto(item)" style="margin-right: 10px;"
                                            variant="text" v-if="item.pbgDataPagamento == null">
                                            <v-icon class="editiconcor">mdi-cash</v-icon>
                                            <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="EmissaoNF(item)" style="margin-right: 10px;" variant="text"
                                            v-if="item.snfId == 10 || item.snfId == 0 || item.snfId == 40">
                                            <v-icon class="editiconcor">mdi-file-code</v-icon>
                                            <v-tooltip activator="parent" location="top">Emissão e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="BaixaNF(item, '1')" style="margin-right: 10px;"
                                            variant="text" v-if="item.snfId == 50">
                                            <v-icon class="editiconcor"
                                                style="color: green;">mdi-file-powerpoint</v-icon>
                                            <v-tooltip activator="parent" location="top">Baixar Pdf e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="BaixaNF(item, '2')" style="margin-right: 10px;"
                                            variant="text" v-if="item.snfId == 50">
                                            <v-icon class="editiconcor" style="color: green;">mdi-file-excel</v-icon>
                                            <v-tooltip activator="parent" location="top">Baixar xml e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="ModalStatus(item)" style="margin-right: 10px;"
                                            variant="text"
                                            v-if="item.snfId == 35 || item.snfId == 40 || item.snfId == 0">
                                            <v-icon class="editiconcor" style="color: orange;">mdi-file-find</v-icon>
                                            <v-tooltip activator="parent" location="top">Status e-NF</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="CancelarNF(item)" style="margin-right: 10px;" variant="text"
                                            v-if="item.snfId == 50">
                                            <v-icon class="editiconcor" style="color: red;">mdi-file-remove</v-icon>
                                            <v-tooltip activator="parent" location="top">Cancelar e-NF</v-tooltip>
                                        </v-btn>
                                        <div v-if="item.snfId == 20 || item.snfId == 30">Processando</div>
                                        </div>
                                    </template>
                                    <template #item-select="item">
                                        <div class="gp-selection-cell" v-if="item.pbgDataPagamento == null">
                                            <v-checkbox v-model="itemsSelected" :value="item" density="compact" hide-details></v-checkbox>
                                        </div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-row justify="center">
        <v-dialog v-model="dialogPagamento" persistent transition="dialog-bottom-transition" style="width: 520px;">
            <v-card>
                <v-card-text style="padding: 16px 0px 10px" v-if="itemAtual != ''">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <strong>Garantidora: {{ListGarantidorasGeral.filter(x => x.garId ==
                                        itemAtual.garId)[0].garNomeEmpresa}}</strong>
                                </v-col>
                                <v-col cols="12" md="12">
                                    {{ itemAtual.pbgDescricaoServico }}
                                </v-col>
                                <v-col cols="12" md="12">
                                    Parcela: {{ itemAtual.pbgParcela }}
                                </v-col>
                                <v-col cols="12" md="12">
                                    <label>Valor Parcela</label>
                                    <input v-model="itemAtual.pbgValorGarantepay" type="text" class="form-control"
                                        placeholder="Valor Parcela" />
                                </v-col>
                                <v-col cols="12" md="12">
                                    <label>Data Vencimento</label>
                                    <input v-model="itemAtual.pbgDataVencimento" type="date" class="form-control"
                                        placeholder="Data Vencimento" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <label>Data Pagamento</label>
                                    <input v-model="pmbDataPagamento" type="date" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="" style="padding: 5px;margin: 5px;font-size: 13px;color:#000000;"
                        @click.prevent="dialogPagamento = !dialogPagamento">Cancelar</v-btn>
                    <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 13px;color:#ffffff;"
                        @click.prevent="AtualizaPagamento(pmbDataPagamento)">Atualizar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>

    <v-dialog v-model="dialogStatusNota" max-width="900px">
        <v-card>
            <v-card-title class="text-h6">Histórico de Processamento</v-card-title>
            <v-card-text>
                <adm-data-table :headers="headers2" :items="statusArray" v-model="itemsSelected" alternating
                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="historico-processamento">
                    <template #item-dataEnvio="item">
                        {{ formattedDateHr(item.dataEnvio) }}
                    </template>
                    <template #item-mensagem="item">
                        <div style="max-width: 300px; white-space: normal;">
                            {{ item.mensagem || '-' }}
                        </div>
                    </template>
                </adm-data-table>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialogStatusNota = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'

export default {
    name: 'ControleCobrancasView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        User: [],
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        ListCobrancasGeral: [],
        ListCobrancas: [],
        GarantidoraSelected: null,
        ListGarantidorasGeral: [],
        ImobiliariaSelected: null,
        ListImobiliariasGeral: [],
        ListImobiliarias: [],
        PagamentoSelected: null,
        ListPagamentosGeral: [],
        AnoSelected: null,
        ListAnoGeral: [],
        MesSelected: null,
        ListMesGeral: [
            { Id: 1, Nome: 'Janeiro' },
            { Id: 2, Nome: 'Fevereiro' },
            { Id: 3, Nome: 'Março' },
            { Id: 4, Nome: 'Abril' },
            { Id: 5, Nome: 'Maio' },
            { Id: 6, Nome: 'Junho' },
            { Id: 7, Nome: 'Julho' },
            { Id: 8, Nome: 'Agosto' },
            { Id: 9, Nome: 'Setembro' },
            { Id: 10, Nome: 'Outubro' },
            { Id: 11, Nome: 'Novembro' },
            { Id: 12, Nome: 'Dezembro' }
        ],
        SituacaSelected: null,
        ListSituacaoGeral: [
            { Id: 1, Nome: 'Pago' },
            { Id: 2, Nome: 'Em Aberto' },
        ],
        ListClientes: [],
        ListClientesGeral: [],
        itemAtual: '',
        pmbDataPagamento: '',
        dialogPagamento: false,
        itemsSelected: [],
        NewData: '',
        selectedConsumidor: null,
        ListConsumidor: [],
        TotalFiltro: 0,
        dialogStatusNota: false,
        headers2: [
            { text: 'ID', value: 'snfId', align: 'start' },
            { text: 'Status', value: 'snfNome' },
            { text: 'Data de Envio', value: 'dataEnvio' },
            { text: 'Observação', value: 'mensagem' }
        ],
        statusArray: [],
    }),
    computed: {
        gridHeaders() {
            const colunasAgrupadas = new Set(['garId', 'plano', 'pbgDescricaoServico']);
            const resultado = [];
            this.headers.forEach(header => {
                if (header.value === 'garId') {
                    resultado.push({ text: 'Garantidora / Plano / Produto', value: 'resumoCobranca', sortable: false });
                } else if (!colunasAgrupadas.has(header.value)) {
                    resultado.push(header);
                }
            });
            return resultado;
        },
        cabecalhoExportacao() {
            const nome = (lista, campoId, selecionado, campoNome, padrao) =>
                lista.find(item => item[campoId] == selecionado)?.[campoNome] || padrao;
            return [
                { label: 'Garantidora', value: nome(this.ListGarantidorasGeral, 'garId', this.GarantidoraSelected, 'garNomeEmpresa', 'Todas') },
                { label: 'Forma de Pagamento', value: nome(this.ListPagamentosGeral, 'cfpId', this.PagamentoSelected, 'cfpNome', 'Todas') },
                { label: 'Ano', value: nome(this.ListAnoGeral, 'Id', this.AnoSelected, 'Nome', 'Todos') },
                { label: 'Mês', value: nome(this.ListMesGeral, 'Id', this.MesSelected, 'Nome', 'Todos') },
                { label: 'Situação', value: nome(this.ListSituacaoGeral, 'Id', this.SituacaSelected, 'Nome', 'Todas') }
            ];
        },
        formatadoresExportacao() {
            return {
                garId: (_, item) => `${item.garantidora || ''}${item.documento ? ` - ${item.documento}` : ''}`,
                pbgValorGarantepay: value => Number(value || 0),
                pbgValorBase: value => Number(value || 0),
                pbgDataVencimento: value => value ? this.formattedDate(value) : '',
                pbgDataPagamento: value => value ? this.formattedDate(value) : ''
            };
        },
        formatosNumericosExportacao() {
            return { pbgValorGarantepay: '#,##0.00', pbgValorBase: '#,##0.00' };
        }
    },
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formattedDateHr(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        Cancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        Filtar() {
            axios.get(`/Telas/ControleCobrancaGarantePay/GetAllPedControleCobrancaGarantePay`)
                .then(response => {
                    this.ListCobrancasGeral = response.data;
                    if (this.GarantidoraSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.garId == this.GarantidoraSelected);
                    }
                    if (this.PagamentoSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pbgTipoPgto == this.PagamentoSelected);
                    }
                    if (this.AnoSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => this.$moment(x.pbgDataVencimento).format('YYYY') == this.AnoSelected);
                    }
                    if (this.MesSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => this.$moment(x.pbgDataVencimento).format('M') == this.MesSelected);
                    }
                    if (this.SituacaSelected != null) {
                        if (this.SituacaSelected == 1) {
                            this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pbgDataPagamento != null);
                        }
                        else if (this.SituacaSelected == 2) {
                            this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pbgDataPagamento == null);
                        }
                    }


                    //console.log('this.ListCobrancasGeral')
                    //console.log(this.ListCobrancasGeral)
                    this.ListCobrancas = [...this.ListCobrancasGeral].sort((a, b) =>
                        this.$moment(a.pbgDataVencimento).diff(this.$moment(b.pbgDataVencimento))
                    );

                    const totalCentavos = (this.ListCobrancas || []).reduce((acc, item) => {
                        const n = Number(item?.pbgValorGarantepay ?? 0); // aceita number ou string "569.25"
                        return acc + Math.round(n * 100);
                    }, 0) / 100;

                    this.TotalFiltro = totalCentavos.toLocaleString('pt-BR', {
                        style: 'currency', currency: 'BRL'
                    });
                });
        },
        ConfirmaPgto(item) {
            item.pbgDataVencimento = this.$moment(item.pbgDataVencimento).format('YYYY-MM-DD')
            item.pbgValorGarantepay = this.formatarValor(item.pbgValorGarantepay);
            this.itemAtual = item;

            this.dialogPagamento = true;
        },
        isDecimalPtBr2Casas(str) {
            const v = String(str ?? '').trim();
            const re = /^(?:R\$\s*)?-?(?:\d{1,3}(?:\.\d{3})+|\d+),\d{2}$/;
            return re.test(v);
        },
        AtualizaPagamento(pbgDataPagamento) {
            if (this.itemAtual.pbgDataVencimento == '' || this.itemAtual.pbgDataVencimento == null) {
                this.$mensagemErro('Selecione Vencimento do pagamento.');
            }
            else if (this.itemAtual.pbgValorGarantepay == '' || this.itemAtual.pbgValorGarantepay == null) {
                this.$mensagemErro('Selecione Valor do pagamento.');
            }
            else if (!this.isDecimalPtBr2Casas(this.itemAtual.pbgValorGarantepay)) {
                this.$mensagemErro('Formato do valor inválido (###.###,##).');
            }
            else {
                let _valorGarantePay = this.itemAtual.pbgValorGarantepay.replaceAll('.', '').replaceAll(',', '.');
                this.$mensagemConfirma('Confirma Alterações nessa Fatura?')
                    .then((result) => {
                        if (result.isConfirmed) {
                            // Lógica para excluir o item
                            let _dados = {
                                PbgId: this.itemAtual.pbgId,
                                PbgDataPagamento: pbgDataPagamento != '' ? this.$moment(pbgDataPagamento).format('YYYY-MM-DD') : null,
                                PbgDataVencimento: this.$moment(this.itemAtual.pbgDataVencimento).format('YYYY-MM-DD'),
                                PbgValorGarantepay: parseFloat(_valorGarantePay),
                                PbgTipoPgto: this.itemAtual.pbgTipoPgto,
                                PbgFormaPgto: this.itemAtual.pbgFormaPgto,
                                PbgEnvioBanco: null,
                                PbgRetornoBanco: null
                            }
                            // console.log('_dados')
                            // console.log(_dados)
                            axios.put(`/Telas/ControleCobrancaGarantePay/UpdateSituacaoPgto`, _dados)
                                .then(response => {
                                    if (response.status == 200) {
                                        this.Filtar();
                                        this.dialogPagamento = false;
                                    }
                                });
                        }
                    });
            }
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "", value: "select", width: 52, sortable: false });
             this.headers.push({ text: "Id", value: "pbgId", sortable: true, });
            this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            this.headers.push({ text: "Plano", value: "plano", sortable: true, });
            this.headers.push({ text: "Produto", value: "pbgDescricaoServico", sortable: true, });
            this.headers.push({ text: "Tipo", value: "pbgFormaPgto", sortable: true, });
            this.headers.push({ text: "Valor Base", value: "pbgValorBase", sortable: true, });
            this.headers.push({ text: "Percentual GarantePay", value: "pbgRemuneracaoNegocio", sortable: true, });
            this.headers.push({ text: "Parcela", value: "pbgParcela", sortable: true, });
            this.headers.push({ text: "Valor Parcela", value: "pbgValorGarantepay", sortable: true, });
            this.headers.push({ text: "Vencimento", value: "pbgDataVencimento", sortable: true, });
            this.headers.push({ text: "Pagamento", value: "pbgDataPagamento", sortable: true, });
            this.headers.push({ text: "Dias Atraso", value: "diasVencidos", sortable: true, });
            //this.headers.push({ text: "Status", value: "snfId", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });

        },
        exportCSV() {
            if (this.ListCobrancas.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }

            let _Garantidora = "Todas";
            let _FormaPagamento = "Todas";
            let _Ano = "Todos";
            let _Mes = "Todos";

            if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
                _Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa;
            }

            if (this.PagamentoSelected != '' && this.PagamentoSelected != null) {
                _FormaPagamento = this.ListPagamentosGeral.filter(x => x.cfpId == this.PagamentoSelected)[0].cfpNome;
            }

            if (this.AnoSelected != '' && this.AnoSelected != null) {
                _Ano = this.ListAnoGeral.filter(x => x.Id == this.AnoSelected)[0].Nome;
            }

            if (this.MesSelected != '' && this.MesSelected != null) {
                _Mes = this.ListMesGeral.filter(x => x.Id == this.MesSelected)[0].Nome;
            }

            // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
            const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Forma Pagamento: ${_FormaPagamento}\n` +
                `Ano: ${_Ano}\n` +
                `Mês: ${_Mes}\n\n`;

            const csvHeader = this.headers
                .slice(1)
                .map(h => h.text)
                .join(";") + "\n";

            // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
            const keys = this.headers
                .slice(1)
                .map(h => h.value);


            const csvRows = this.ListCobrancas
                .map(item => {
                    return keys
                        .map(key => {
                            if (key === "garId") {

                                // encontra o cliente correspondente
                                const cli = this.ListGarantidorasGeral.find(c => c.garId === item.garId) || {};
                                return cli["garNomeEmpresa"] + " - " + cli["garDocumento"] || "";
                            }
                            if (key === 'pbgValorGarantepay') {
                                return this.formatarValor(item.pbgValorGarantepay);
                            }
                            if (key === 'pbgValorBase') {
                                return this.formatarValor(item.pbgValorBase);
                            }

                            if (key === 'pbgDataVencimento' || key === 'pbgDataVencimento') {
                                return item[key]
                                    ? this.formattedDate(item[key])
                                    : '';
                            }
                            if (key === 'pbgDataPagamento' || key === 'pbgDataPagamento') {
                                return item[key]
                                    ? this.formattedDate(item[key])
                                    : '';
                            }

                            // para os demais campos, pega direto do item
                            return item[key] != null ? item[key] : "";
                        })
                        .join(";");
                })
                .join("\n");

            // Concatena os filtros, o cabeçalho e as linhas de dados
            const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + filtroCSV + csvHeader + csvRows;

            // Cria o link de download
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "RelatorioControleCobrancasGarantePay.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        AtualizarPagamentoMassa() {
            if (!this.NewData) {
                return this.$mensagemErro('Selecione uma data de pagamento.');
            }

            if (this.itemsSelected.length == 0) {
                return this.$mensagemErro('Selecione um registro para confirmar pagamento.');
            }

            this.$mensagemConfirma('Confirma atualização de todos os itens selecionados?')
                .then(result => {
                    if (!result.isConfirmed) return;
                    // para cada item selecionado, chama o endpoint
                    const promessas = this.itemsSelected.map(item => {
                        const payload = {
                            PbgId: item.pbgId,
                            PbgDataPagamento: this.$moment(this.NewData).format('YYYY-MM-DD'),
                            PbgDataVencimento: this.$moment(item.pbgDataVencimento).format('YYYY-MM-DD'),
                            PbgValorGarantepay: item.pbgValorGarantepay,
                            PbgTipoPgto: item.pbgTipoPgto,
                            PbgFormaPgto: item.pbgFormaPgto,
                            PbgEnvioBanco: null,
                            PbgRetornoBanco: null
                        };
                        return axios.put(
                            `/Telas/ControleCobrancaGarantePay/UpdateSituacaoPgto`,
                            payload
                        );
                    });

                    // aguarda todas responderem
                    Promise.all(promessas)
                        .then(() => {
                            this.$mensagemSucesso('Pagamentos atualizados com sucesso.');
                            this.Filtar();          // recarrega a lista
                            this.itemsSelected = []; // limpa seleção
                        })
                        .catch(() => {
                            this.$mensagemErro('Erro ao atualizar alguns pagamentos.');
                        });
                });
        },
        EmissaoNF(value) {
            this.$mensagemConfirma('Confirma Emissão da Nota?')
                .then((result) => {
                    if (result.isConfirmed) {
                        axios.put(`/Telas/ControleCobrancaGarantePay/UpdateEmitirNotaFiscal/` + value.pbgId)
                            .then(response => {
                                if (response.status == 200) {
                                    this.Filtar();
                                }
                            });
                    }
                });
        },
        async EmissaoNF2() {
            //const _pgbId = [48,139,153,166,292,319,345,369,376,386,408,413,447,453,467,494,509,512,529,613,695,743,745,752,753,756,758,761,763,769,791,795,803,843];
            const _pgbId = [749];
            try {
                const requests = _pgbId.map(id =>
                    axios.put(`/Telas/ControleCobrancaGarantePay/UpdateEmitirNotaFiscal/${id}`)
                );

                const responses = await Promise.all(requests);

                console.log("Todas executadas:", responses);
            } catch (error) {
                console.error("Erro em alguma requisição:", error);
            }
        },
        CancelarNF(item) {
            this.$mensagemConfirma('Confirma Cancelamento da Nota?')
                .then((result) => {
                    if (result.isConfirmed) {
                        axios.put(`/Telas/ControleCobrancaGarantePay/UpdateCancelarNotaFiscal/` + item.pbgId + '/' + item.idNota)
                            .then(response => {
                                if (response.status == 200) {
                                    this.Filtar();
                                }
                            });
                    }
                });
        },
        async CancelarNF2() {
           /* const _pgbId = [
                749, 292, 319, 345, 48, 139, 153, 166, 292, 319, 345, 369,
                376, 386, 408, 413, 447, 453, 467, 494, 509, 512, 529,
                613, 695, 743, 745, 752, 753, 756, 758, 761, 763, 769,
                791, 795, 803, 843
            ];*/

              const _pgbId = [749];

            const idsSet = new Set(_pgbId);

            const listaFiltrada = this.ListCobrancas.filter(item =>
                idsSet.has(item.pgbId) && item.idNota
            );

            try {
                const requests = listaFiltrada.map(item =>
                    axios.put(`/Telas/ControleCobrancaGarantePay/UpdateCancelarNotaFiscal/${item.pgbId}/${item.idNota}`)
                );

                const responses = await Promise.all(requests);

                console.log("Todas executadas:", responses);
            } catch (error) {
                console.error("Erro em alguma requisição:", error);
            }
        },
        BaixaNF(value, tipo) {
            const url = `/Telas/ControleCobrancaGarantePay/GetFile/${value.pbgId}/${tipo}`;

            axios.get(url, { responseType: 'blob' })
                .then(response => {
                    console.log('response.data')
                    console.log(response.data)
                    const blob = new Blob([response.data], { type: response.data.type });
                    const fileURL = URL.createObjectURL(blob);

                    if (tipo === 1 || tipo === "1") {
                        // PDF: abrir em nova aba
                        window.open(fileURL, '_blank');
                    } else if (tipo === 2 || tipo === "2") {
                        // XML: forçar download
                        const link = document.createElement('a');
                        link.href = fileURL;

                        // Tenta extrair o nome do arquivo do header (se definido)
                        const contentDisposition = response.headers['content-disposition'];
                        let fileName = 'arquivo.xml'; // nome padrão

                        if (contentDisposition) {
                            const fileNameMatch = contentDisposition.match(/filename\*?=(?:UTF-8'')?"?([^;"]+)"?/);
                            if (fileNameMatch && fileNameMatch[1]) {
                                fileName = decodeURIComponent(fileNameMatch[1]);
                            }
                        }

                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(fileURL); // libera a memória
                    }
                })
                .catch(error => {
                    console.error('Erro ao baixar arquivo:', error);
                });
        },
        ModalStatus(item) {
            axios.get(`/Telas/ControleCobrancaGarantePay/GetRetornoWebhookApi/` + item.pbgId)
                .then(response => {
                    this.statusArray = response.data.sort((a, b) => {
                        return new Date(b.dataEnvio) - new Date(a.dataEnvio);
                    });
                    this.dialogStatusNota = true;
                });
        },
        async Get() {

            await axios.get(`/Telas/ControleCobrancaGarantePay/GetDados`)
                .then(response => {
                    this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );

                    this.ListAnoGeral = [];
                    const anoAtual = new Date().getFullYear();
                    this.ListAnoGeral = Array.from({ length: 7 }, (_, i) => {
                        const ano = anoAtual - 1 + i;
                        return { Id: ano, Nome: String(ano) };
                    });

                    this.ListPagamentosGeral = response.data.cadFormasPagamentos;
                    this.montaGrid();
                });

        },
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
